// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3tgAa","file":"styles_file__2b32D"};